import { render, staticRenderFns } from "./AddHomeService.vue?vue&type=template&id=7270b842&scoped=true&"
import script from "./AddHomeService.vue?vue&type=script&lang=js&"
export * from "./AddHomeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270b842",
  null
  
)

export default component.exports